<template>
  <div class="organizationChartOfAccount-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "organizationChartOfAccountBase",
};
</script>
